module.exports = __webpack_public_path__ + "img/Gimnasio.b8d71669.png";